import {createGrid} from "../../helpers/grids/grids";
import createElement from "../../helpers/createElement";
import {createCellRenderer} from "../../helpers/grids/helpers";
import {getLinkifiedPublicId} from "../../helpers/linkifyContent";

function initCompaniesDetail() {

	// Init grid
	const orderCompanyGrid = document.querySelector('.orders-company-grid');
	if (orderCompanyGrid) {
		createGrid(orderCompanyGrid, {
				columnDefs: [
					{
						field: "public_id",
						headerName: 'Order Id',
						tooltipField: 'public_id',
						cellRenderer: createCellRenderer(params => {
							const detailUrl = params.data.detailUrl
							const public_id = params.data.public_id
							return getLinkifiedPublicId({detailUrl, public_id})
						}),
					},
					{
						field: "status_label",
						headerName: 'Status',
						sortable: false,

					},
					{
						field: "assigned_to_full_name",
						headerName: 'Assigned To',
						sortable: false,
						cellRenderer: createCellRenderer(params => {
							// noinspection JSUnresolvedVariable
							return params.data.assigned_to_full_name ?
								params.data.assigned_to_full_name :
								createElement('<span class="text-muted">On Queue</span>');
						})
					},
				],

				rowClass: 'cursor-pointer',
				paginationPageSize: 20,
				_rowName: 'Assigned Orders',
			},
			window['routes/admin.voe-orders.assigned-company-orders.grid']
		);

	}

}

export {initCompaniesDetail}
